import { Attributes } from '@singularsystems/neo-core';
import DividendBaseCriteria from './DividendBaseCriteria';

export default class InvestorDividendCriteria extends DividendBaseCriteria {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public issuerInvestmentName: string = "";

    public toString(): string {
        return "Investor Dividend Criteria";
    }
}